/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Abt_Belief_TitleInputs */

const en_mk_abt_belief_title = /** @type {(inputs: Mk_Abt_Belief_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Five things that shaped this product`)
};

const id_mk_abt_belief_title = /** @type {(inputs: Mk_Abt_Belief_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lima hal yang membentuk produk ini`)
};

/**
* | output |
* | --- |
* | "Five things that shaped this product" |
*
* @param {Mk_Abt_Belief_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_abt_belief_title = /** @type {((inputs?: Mk_Abt_Belief_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Abt_Belief_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_abt_belief_title(inputs)
	return en_mk_abt_belief_title(inputs)
});